import { render } from "./QuestionCard.vue?vue&type=template&id=647e94fb&scoped=true"
import script from "./QuestionCard.vue?vue&type=script&lang=js"
export * from "./QuestionCard.vue?vue&type=script&lang=js"

import "./QuestionCard.vue?vue&type=style&index=0&id=647e94fb&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647e94fb"]])

export default __exports__